import React, { ReactElement, FunctionComponent } from "react";
import classNames from "classnames";

export interface FeatureGroupIconTitleProps {
    title: string | ReactElement<any>;
    className?: string;
    iconClassName: string;
}

export const FeatureGroupIconTitle: FunctionComponent<FeatureGroupIconTitleProps> = ({
    title,
    className,
    iconClassName,
}) => {
    return (
        <div className={classNames("feature_group_title", className)}>
            <span className={iconClassName} aria-hidden />
            <div className="feature_group_label">{title}</div>
        </div>
    );
};
